import React from 'react';
import Sidebar from './Sidebar';

/** @deprecated Prefer <Sidebar mode="project" /> — kept for import compatibility */
export default function ProjectSidebar(props) {
  return <Sidebar mode="project" {...props} />;
}
